<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
           <a-col :span="24">
            <a-form-item label="应用名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name']" :disabled="model.name"/>
        </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="appkey" :labelCol="labelCol" :wrapperCol="wrapperCol" > 
          <a-input v-decorator="[ 'appKey']" disabled />
        </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="appsecrect" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'appSecrect']"   style="width: 85%" />
          <a-button @click="refreshAppSecrect" style="margin-left:2%">刷 新</a-button>
        </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="token" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-decorator="[ 'token']" style="width: 85%" />
          <a-button @click="refreshToken" style="margin-left:2%">刷 新</a-button>
        </a-form-item>
        <a-form-item label="失效时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            placeholder="请选择失效时间"
            v-decorator="['expiredTime']"
            />
        </a-form-item>
          </a-col>
         
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JSelectMultiUser from '@/components/jeecgbiz/JSelectMultiUser'

  

  export default {
    name: 'SysTokenForm',
    components: {
      JFormContainer,
      JDate,
      JSelectMultiUser
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/system/sysToken/add",
          edit: "/system/sysToken/edit",
          queryById: "/system/sysToken/queryById"
        },
        // 选择用户查询条件配置
        selectUserQueryConfig: [
          {},
        ]
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      
      add () {
        this.edit(null);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record==null){
          httpAction("/system/sysToken/init-systoken",null,'get').then((res)=>{
          if(res.success){
              this.model.appKey=res.result.appKey;
              this.model.appSecrect=res.result.appSecrect;
              
              this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'appKey','appSecrect','token'))
              })
          }else{ 
              this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
        })  
        }else{
          this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'appKey','appSecrect','token','name','expiredTime'))
              })
        }
        
      
        
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      refreshAppSecrect () {
       httpAction("/system/sysToken/init-systoken",null,'get').then((res)=>{
          if(res.success){
              this.model.appSecrect=res.result.appSecrect;
              this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'appSecrect'))
              })
          }else{ 
              this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
        })  
      },
      refreshToken () {
        var tokenParams = {appKey:this.model.appKey,appSecrect:this.model.appSecrect}
       httpAction("/system/sysToken/create/token",tokenParams,'post').then((res)=>{
          if(res.success){
              this.model.token=res.message;
              this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'token'))
              })
          }else{ 
              this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
        }) 
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'id','expiredTime','name'))
      },
    }
  }
</script>